<template>
  <v-container fluid class="loginWrapper">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="4" md="4" class="loginForm">
        <v-snackbar class="loginSnackBar" centered :timeout="3000" :value="loginFailed">
          Logindaten fehlerhaft

          <template v-slot:action="{attrs}">
            <v-btn
                color="transparent"
                elevation="0"
                rounded
                v-bind="attrs"
                @click="close"
            >
              x
            </v-btn>
          </template>
        </v-snackbar>
        <v-card class="loginCard" elevation="0">
          <v-card-text class="pb-0">
            <v-form v-model="valid" ref="form">
              <v-text-field
                label="Benutzername"
                type="text"
                v-model="username"
                :rules="usernameRules"
                rounded solo
              >
              </v-text-field>

              <!--
              <v-text-field
                  label="Kundennummer"
                  type="text"
                  v-model="customerId"
                  :rules="customerIdRules"
                  rounded solo
              >
              </v-text-field>
              -->
                <transition name="slide-fade" mode="out-in">
                  <v-text-field
                      label="Passwort"
                      type="password"
                      v-model="password"
                      rounded solo
                      v-if="!firstLogin"
                  >
                  </v-text-field>
                  <div v-if="firstLogin" class="loginCheckBxTxtWrapper">
                    <span class="loginCheckBxTxt">
                      Du wirst zur erstmaligen Vergabe Deines Passwortes weitergeleitet.
                    </span>
                  </div>
                </transition>
            </v-form>
          </v-card-text>
          <v-card-actions class="pa-4 pt-0">
            <v-checkbox v-model="firstLogin"
                        label="Ich melde mich zum ersten Mal an."
                        class="mr-2"
            >
            </v-checkbox>
            <v-btn type="submit" :disabled="!valid" @click="loginAttempt" rounded large
                    depressed
                    class="loginBtn"
            >
              <span>Login</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  data()  {
    return {
      valid: true,
      firstLogin: false,
      showPassField: true,
      showInfoField: false,
      username : '',
      customerId : '',
      password : '',
      usernameRules: [v => !!v],
      customerIdRules: [v => !!v]
    }
  },
  name: "LoginForm",
  methods: {
    ...mapActions({
      login: 'login',
      closeSnackbar: 'closeSnackbar'
    }),

    loginAttempt(){
      this.login(this.credentials).then((redirect) => {
          this.$router.push({path: '/'+redirect})
      })
    },

    close(){
      this.closeSnackbar(false).then(() => {
            this.username= ''
            this.customerId= ''
            this.password= ''
      })
    },
  },

  computed: {
    credentials() {
      const {username} = this
      const {customerId} = "1"
      const {password} = this
      return {
        username,
        customerId,
        password
      }
    },
    ...mapState({
      loginFailed : 'loginFailed',
      loginInfoText: 'loginInfoText'
    }),
  },

  watch: {
    firstLogin: {
      handler(show) {
        if(show) {
          this.showPassField = false
          this.showInfoField= true
        }

        else {
          this.showInfoField = false
          this.showPassField = true
        }
      }
    }
  }
}
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s ease;
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active for <2.1.8 */ {
  opacity: 0;
}

.loginCheckBxTxtWrapper {
  min-height: 56px;
  display: table;
}

.loginCheckBxTxt {
  display: table-cell;
  vertical-align: middle;
}

</style>